var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "flex flex-wrap justify-space-between",
      attrs: { "data-test": "tab-share--channels" }
    },
    _vm._l(_vm.channels, function(channel, index) {
      return _c(
        "li",
        { attrs: { "data-test": "tab-share--channels--" + channel } },
        [
          _c(channel + "-channel", {
            tag: "component",
            attrs: {
              "aria-label": _vm.$t(
                _vm.a11y(channel).key,
                _vm.a11y(channel).attr
              ),
              a11y: _vm.$t(_vm.a11y.key, { channel: channel })
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }